module.exports = __webpack_public_path__ + "static/media/image-8.e75e3b19.jpg";